import { render, staticRenderFns } from "./CouponsendDialog.vue?vue&type=template&id=0b01245a&scoped=true"
import script from "./CouponsendDialog.vue?vue&type=script&lang=js"
export * from "./CouponsendDialog.vue?vue&type=script&lang=js"
import style0 from "./CouponsendDialog.vue?vue&type=style&index=0&id=0b01245a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01245a",
  null
  
)

export default component.exports